import { Reducer } from "redux";
import { Action, ActionType } from "../actions";
import { NotificationProps } from "../state/NotificationState";


const updateNotifications: Reducer<NotificationProps[]> = (state: NotificationProps[] = [], action: Action<ActionType, NotificationProps>) => {
  let indexToRemove = -1;
  switch (action.type) {
    case ActionType.ADD_NOTIFICATION:
      if (action.data.id != null) {
        indexToRemove = state.findIndex((n) => n.id === action.data.id);
      } else {
        indexToRemove = state.findIndex(n => JSON.stringify(n) === JSON.stringify(action.data));
      }
      if (indexToRemove > -1) {
        return state;
      }
      state.push(action.data);
      return [...state];
    case ActionType.REMOVE_NOTIFICATION:
      if (action.data.id != null) {
        indexToRemove = state.findIndex((n) => n.id === action.data.id);
      } else {
        indexToRemove = state.findIndex(n => JSON.stringify(n) === JSON.stringify(action.data));
      }
      if (indexToRemove > -1) {
        state.splice(indexToRemove, 1);
        return [...state];
      }
      return state;
    default:
      return state;
  }
}

export default updateNotifications;